import { Component } from '@angular/core';

/**
 * Target of the root '/' route. Renders nothing itself — the persistent
 * <app-map> plus the sidebar's view-tab overlays ARE the map workspace. This
 * route exists so '/' is a real, matchable route: navigating there resolves
 * cleanly (a NavigationEnd) instead of relying on the "no route matched"
 * fall-through.
 */
@Component({
  selector: 'app-workspace-root',
  template: '',
})
export class WorkspaceRootComponent {}
